"use client";
import { loadStoryblokBridge as n, registerStoryblokBridge as e } from "./storyblok-js.mjs";
import { useEffect as l, startTransition as d } from "react";
import { liveEditUpdateAction as s } from "./live-edit-update-action.mjs";
import { isVisualEditor as u, isBridgeLoaded as f } from "./utils.mjs";
const S = ({ story: t = null, bridgeOptions: o = {} }) => {
  if (!u())
    return null;
  const r = (t == null ? void 0 : t.id) ?? 0;
  return l(() => {
    (async () => {
      f() || await n();
      const a = (i) => {
        i && d(() => {
          s({ story: i, pathToRevalidate: window.location.pathname });
        });
      };
      e(r, (i) => a(i), o);
    })();
  }, [r, JSON.stringify(o)]), null;
};
export {
  S as default
};
